import { useState } from 'react'

const useRequestStatus = () => {
  const [isOpen, setIsOpen] = useState()
  const [title, setTitle] = useState('')
  const [body, setBody] = useState(null)
  const [code, setCode] = useState(null)
  const [customColor, setCustomColor] = useState(null)
  const handleOpen = () => {
    setIsOpen(true)
  }
  const handleClose = (callback) => {
    setIsOpen(false)
    setTitle('')
    if (typeof callback === 'function') callback?.()
    setCustomColor(null)
  }
  const handleSetTitle = (newTitle, newCode) => {
    setTitle(newTitle)
    setCode(newCode)
  }

  const handleChangeBody = (bodyComponent) => {
    setBody(bodyComponent)
  }
  const handleChangeCustomColor = (customColor) => {
    setCustomColor(customColor)
  }
  return {
    isOpen,
    title,
    handleClose,
    handleOpen,
    handleSetTitle,
    handleChangeBody,
    handleChangeCustomColor,
    body,
    code,
    customColor,
  }
}

export default useRequestStatus
